const LinkButton = ({ label, onClick, icon, disabled }) => {
  return (
    <div
      className={`leading-8 min-w-40 items-center justify-center self-start flex gap-1 px-5 py-1
       ${
         disabled
           ? 'text-[#bbb] fill-[#bbb] outline cursor-not-allowed'
           : 'text-gray-600 dark:text-zinc-400 fill-gray-600 dark:fill-zinc-400 cursor-pointer hover:text-[#070707] hover:fill-[#070707] dark:hover:text-white dark:hover:fill-white'
       }`}
      onClick={onClick}
    >
      {icon}
      <span>{label}</span>
    </div>
  )
}

export default LinkButton
